module.exports = __webpack_public_path__ + "static/media/present_icon.d2610ab1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/present_icon.svg
// module id = 162
// module chunks = 0